var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5a.997.997 0 0 0 .707-.293l4-4a.999.999 0 1 0-1.414-1.414l-3.305 3.305-3.293-3.18a1 1 0 0 0-1.39 1.44l4 3.861A.997.997 0 0 0 12 15.5Z",
    fill: "#008545"
  })));
};
export default SvgArrowDown;